'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getList();
    this.getScreenSaver(this.$stateParams.id);
  }

  getScreenSaver(id) {
    this.$http.get(`/api/screenSavers/${id}`).then(res => {
      this.saver = res.data;
    });
  }

  update() {
    this.$http.put(`/api/screenSavers/${this.$stateParams.id}`, this.saver).then(res => {
      this.$state.go('screensavers.list');
    });
  }

  getList() {
    this.$http.get('/api/AppConfGroups').then(res => {
      this.groups = res.data;
    });
  }

  toggleSelection(id) {
    let idx = this.saver.modelGroups.indexOf(id);
    if (idx > -1) {
      this.saver.modelGroups.splice(idx, 1);
    } else {
      this.saver.modelGroups.push(id);
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/screenSaver/edit/edit.controller.js